import request from './request'

let roles = []
let flag = true
let reqPromise = null

export default async function (arg, value) {
  if (arg && value) {
    try {
      if (flag) {
        flag = false

        reqPromise = request({
          url: '/api-u/api/saas/user/appButtonRoleList',
          method: 'post',
          loading: false,
        })

        window.setTimeout(() => (flag = true), 500)
      }
    } catch (e) {
      console.error(e)
      return false
    }

    const res = await reqPromise

    roles = res.data || []

    const permissionRole = `${arg}:${value}`

    const hasPermission = roles.some((role) => {
      return permissionRole === role
    })

    return hasPermission
  } else {
    return true
  }
}
